var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/modal/common/src/modal-props.ts
import { lightTheme } from "@gs-ux-uitoolkit-common/theme";
var defaultSize = "md";
var modalDefaultProps = {
  backdrop: true,
  hideOnEscape: true,
  placement: "top",
  scrollable: false,
  size: defaultSize,
  theme: lightTheme
};
var modalHeaderDefaultProps = {
  dismissible: true,
  size: defaultSize
};
var modalBodyDefaultProps = {
  size: defaultSize
};
var modalFooterDefaultProps = {
  size: defaultSize
};

// components/modal/common/src/modal-style-sheet.ts
import { zIndex } from "@gs-ux-uitoolkit-common/design-system";
import { DEFAULT_BREAKPOINTS } from "@gs-ux-uitoolkit-common/layout";
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var modalStyleSheet = new StyleSheet("modal", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.modal
  );
});
function createDefaultStyledClasses({
  theme,
  size,
  placement
}) {
  const modalElevation = "05";
  let dialogWidth = "608px";
  if (size === "sm") {
    dialogWidth = "400px";
  } else if (size === "lg") {
    dialogWidth = "1024px";
  }
  const centeredStyles = placement === "center" ? {
    alignItems: "center",
    minHeight: "calc(100% - 1rem)"
  } : {};
  return {
    wrapper: {
      position: "relative"
    },
    documentScrollLock: {
      overflow: "hidden",
      "#{root}": {
        overflowX: "hidden",
        overflowY: "auto"
      }
    },
    root: {
      boxSizing: "border-box",
      position: "fixed",
      top: 0,
      left: 0,
      padding: "40px 16px",
      zIndex: zIndex.modal,
      width: "100%",
      height: "100%",
      [`@media (min-width: ${DEFAULT_BREAKPOINTS.xs}px)`]: {
        paddingLeft: "16px",
        paddingRight: "16px"
      },
      [`@media (min-width: ${DEFAULT_BREAKPOINTS.sm}px)`]: {
        paddingLeft: "24px",
        paddingRight: "24px"
      },
      [`@media (min-width: ${DEFAULT_BREAKPOINTS.md}px)`]: {
        paddingLeft: "32px",
        paddingRight: "32px"
      }
    },
    dialog: __spreadValues({
      color: theme.text.primary,
      position: "relative",
      maxWidth: "100%",
      display: "flex",
      margin: "0 auto",
      pointerEvents: "none",
      width: dialogWidth
    }, centeredStyles),
    backdrop: {
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: zIndex.modalBackdrop,
      width: "100vw",
      height: "100vh",
      backgroundColor: theme.colorScheme.overlay,
      opacity: 0.5,
      "> div": {
        transform: "none",
        transition: "transform .3s ease-out"
      }
    },
    content: {
      background: theme.elevation[modalElevation].background,
      boxShadow: theme.elevation[modalElevation].shadow,
      display: "flex",
      flexDirection: "column",
      pointerEvents: "auto",
      position: "relative",
      width: "100%"
    }
  };
}

// components/modal/common/src/modal-body-style-sheet.ts
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";
var modalBodyStyleSheet = new StyleSheet2(
  "modalBody",
  (props) => {
    var _a;
    return createComponentClassDefinitions2(
      props,
      createDefaultStyledClasses2,
      (_a = props.theme.styleOverrides) == null ? void 0 : _a.modalBody
    );
  }
);
function createDefaultStyledClasses2({
  theme,
  size
}) {
  let bodyVariant = "body02";
  let bodyPadding = "12px 16px 8px";
  if (size === "sm") {
    bodyVariant = "body03";
    bodyPadding = "4px 12px 12px";
  }
  return {
    root: __spreadProps(__spreadValues({}, theme.typography[bodyVariant]), {
      maxHeight: "70vh",
      overflowY: "auto",
      padding: bodyPadding,
      position: "relative"
    })
  };
}

// components/modal/common/src/modal-footer-style-sheet.ts
import { StyleSheet as StyleSheet3 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions3 } from "@gs-ux-uitoolkit-common/theme";
var modalFooterStyleSheet = new StyleSheet3(
  "modalFooter",
  (props) => {
    var _a;
    return createComponentClassDefinitions3(props, createDefaultStyledClasses3, (_a = props.theme.styleOverrides) == null ? void 0 : _a.modalFooter);
  }
);
function createDefaultStyledClasses3({
  size
}) {
  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: size === "sm" ? "8px" : "12px",
      "> *": {
        marginLeft: "8px"
      }
    }
  };
}

// components/modal/common/src/modal-header-style-sheet.ts
import { rgba } from "polished";
import { StyleSheet as StyleSheet4 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions4 } from "@gs-ux-uitoolkit-common/theme";
var modalHeaderStyleSheet = new StyleSheet4(
  "modalHeader",
  (props) => {
    var _a;
    return createComponentClassDefinitions4(props, createDefaultStyledClasses4, (_a = props.theme.styleOverrides) == null ? void 0 : _a.modalHeader);
  }
);
function createDefaultStyledClasses4({
  theme,
  size
}) {
  let headerPadding = "16px 16px 8px";
  let titleVariant = "heading05";
  let closeFontSize = "20px";
  let closeMarginTop = "-1px";
  let closeMarginRight = "-10px";
  if (size === "sm") {
    headerPadding = "12px 12px 8px";
    titleVariant = "heading06";
    closeFontSize = "16px";
    closeMarginTop = "-3px";
    closeMarginRight = "-6px";
  } else if (size === "lg") {
    headerPadding = "20px 16px 8px";
    titleVariant = "heading04";
    closeMarginTop = "3px";
  }
  return {
    root: {
      padding: headerPadding,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start"
    },
    subtitle: __spreadProps(__spreadValues({}, theme.typography.caption01), {
      colors: theme.text.secondary
    }),
    titleContainer: {},
    title: __spreadProps(__spreadValues({}, theme.typography[titleVariant]), {
      margin: "0px"
    }),
    // TODO: Replace with close-button
    dismissButton: {
      backgroundColor: "transparent",
      border: 0,
      color: theme.text.tertiary,
      cursor: "pointer",
      marginRight: closeMarginRight,
      marginTop: closeMarginTop,
      "&:focus": {
        outline: "none"
      },
      "&:focus-visible": {
        outline: `1px solid ${theme.text.link}`
      },
      span: {
        fontSize: closeFontSize,
        "&:hover": {
          backgroundColor: rgba(`${theme.surface.bold}`, 0.1)
        }
      }
    }
  };
}

// components/modal/common/src/modal-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-modal";
var modalClassNameSelector = "gs-uitk-modal__internal-wrapper";
var getDocumentBodyClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.documentScrollLock,
    className,
    overrideClasses && overrideClasses.documentScrollLock
  );
};
var getModalWrapperClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.wrapper,
    overrideClasses && overrideClasses.wrapper,
    `${globalClassName}__wrapper`
  );
};
var getModalClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.root,
    overrideClasses && overrideClasses.root,
    globalClassName,
    modalClassNameSelector
  );
};
var getModalDialogClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.dialog,
    className,
    overrideClasses && overrideClasses.dialog,
    `${globalClassName}__dialog`
  );
};
var getModalContentClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.content,
    overrideClasses && overrideClasses.content,
    `${globalClassName}__content`
  );
};
var getModalBackdropClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.backdrop,
    overrideClasses && overrideClasses.backdrop,
    `${globalClassName}__backdrop`
  );
};
var getModalHeaderClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__header`
  );
};
var getModalHeaderTitleContainerClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.titleContainer,
    overrideClasses && overrideClasses.titleContainer,
    `${globalClassName}__title-container`
  );
};
var getModalHeaderTitleClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.title,
    overrideClasses && overrideClasses.title,
    `${globalClassName}__title`
  );
};
var getModalHeaderSubtitleClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.subtitle,
    overrideClasses && overrideClasses.subtitle,
    `${globalClassName}__subtitle`
  );
};
var getModalHeaderCloseButtonClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.dismissButton,
    overrideClasses && overrideClasses.dismissButton,
    `${globalClassName}__dismiss-button`
  );
};
var getModalBodyClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__body`
  );
};
var getModalFooterClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__footer`
  );
};
export {
  getDocumentBodyClasses,
  getModalBackdropClasses,
  getModalBodyClasses,
  getModalClasses,
  getModalContentClasses,
  getModalDialogClasses,
  getModalFooterClasses,
  getModalHeaderClasses,
  getModalHeaderCloseButtonClasses,
  getModalHeaderSubtitleClasses,
  getModalHeaderTitleClasses,
  getModalHeaderTitleContainerClasses,
  getModalWrapperClasses,
  modalBodyDefaultProps,
  modalBodyStyleSheet,
  modalClassNameSelector,
  modalDefaultProps,
  modalFooterDefaultProps,
  modalFooterStyleSheet,
  modalHeaderDefaultProps,
  modalHeaderStyleSheet,
  modalStyleSheet
};
//# sourceMappingURL=index.mjs.map
